<template>
    <div v-if="isFirstCreate">
        <!--    <div class="country-img">-->
        <!--      <div class="country-img-message">-->

        <!--        &lt;!&ndash;        <p>{{value.creatDate}}</p>&ndash;&gt;-->
        <!--      </div>-->
        <!--    </div>-->
        <div class="foot-message">
            <!--            <div class="detail-brief">-->
            <!--                <ul style="max-width: 60%;">-->
            <!--                    <p class="msg-title">{{value.name}}</p>-->
            <!--                    <li v-for="(val,key) in value" v-if="key==='首都' || key === '人口(单位：万人)'">-->
            <!--                        <span>{{key}}：</span>-->
            <!--                        <span :title="val">{{val|| '-'}}</span>-->
            <!--                    </li>-->
            <!--                </ul>-->
            <!--                <img :src="value.img">-->
            <!--            </div>-->
          <div class="no-data" v-if="!value || !value.length">
            no data
          </div>
            <ul class="foot-message-detail" v-else>
                <el-scrollbar style="height: calc(100% - 30px)">
                    <li v-for="(val,index) of value" :key="index">
                        <template v-for="(value,key) in val">
                            <span><div :title="`${key}：`" class="overflow-hidden-1">{{key}}：</div></span>
                            <p :title="value">{{value|| '-'}}</p>
                        </template>
                    </li>
                </el-scrollbar>
            </ul>
        </div>

    </div>
    <div v-else></div>
</template>

<script>

export default {
  name: 'knowledge-card',
  props: {
    value: Array
  },
  data () {
    return {
      // filterArr: [],
      filterArr: ['置信度', '权重'],
      isFirstCreate: false
    }
  },
  watch: {
    'value': {
      handler () {
        if (!this.isFirstCreate) {
          this.isFirstCreate = true
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="less">
.no-data {
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    /*图片信息*/
    .country-img {
        display: flex;
    }

    .country-img > img {
        width: 96px;
        height: 60px;
        box-shadow: #6c757d52 2px 3px 4px;
    }

    /*.country-img-message {*/
    /*  display: flex;*/
    /*  align-items: center;*/
    /*  !*margin: 0 0 0 5%;*!*/
    /*}*/

    /*.country-img-message p:nth-child(1) {*/
    /*  margin: 11px 0 8px 0;*/
    /*  font-size: 16px;*/
    /*  color: rgba(33, 37, 41, 1);*/
    /*  font-weight: bold;*/
    /*}*/

    /*中间国家信息*/
    .middle-message {
        display: flex;
        align-items: center;
        margin: 2% 0 3% 0;
    }

    .middle-message > div {
        display: flex;
        align-items: center;
        margin: 0 37px 0 0;
        font-size: 14px;
    }

    .middle-message > div > p:nth-child(1) {
        margin: 0 5px 0 0;
        color: #303133;
        font-weight: bold;
    }

    .middle-message > div > p:nth-child(2) {
        color: #6C757D;
        margin: 0 !important;
    }
    .overflow-hidden-1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /*底部信息*/
    .foot-message {
        /*display: flex;*/
        /*flex-wrap: wrap;*/
        height: 100%;
        /*overflow-y: scroll;*/
        font-size: 14px;
        line-height: 25px;
        color: #6C757D;
        margin: 2% 0 0 0;

        .detail-brief {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .msg-title {
                font-size: 16px;
                font-weight: bold;
                line-height: 20px;
                color: #303133;
            }

            img {
                width: 145px;
                height: 91px;
                border: 1px solid #C0C4CC;
            }
        }

        ul, li {
            margin: 0;
            padding: 0;
        }

        li {
            font-size: 14px;
            font-weight: 400;
            line-height: 18px;
            color: #606266;
            padding: 8px 0;
            display: flex;
            flex: 100%;

            span {
                min-width: 70px;

                &:nth-of-type(2) {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .foot-message-detail {
            width: 100%;
            height: 100%;
            /*height: calc(100% - 104px);*/

            li {
                border-bottom: 1px solid #EBEEF5;

                span {
                    min-width: 100px;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 18px;
                    color: #909399;
                }

                p {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                    color: #606266;
                    margin: 0;
                    /*white-space: nowrap;*/
                    /*overflow: hidden;*/
                    /*text-overflow: ellipsis;*/
                }
            }

            /*  > div span:nth-child(1) {*/
            /*    font-weight: bolder;*/
            /*    margin-right: 5px;*/
            /*    flex-shrink: 0;*/
            /*    width: 90px;*/
            /*  }*/
            /*  > div:nth-child(n+5) {*/
            /*    white-space: pre-wrap;*/
            /*  }*/
        }
    }

    ::-webkit-scrollbar {
        width: 3px;
    }
</style>
